import uniqBy from 'lodash/uniqBy';

// Actions
const TOGGLE_MODAL = 'zen/syndicatedStoryModal/TOGGLE_MODAL';
const TOGGLE_RESTRICT_SEARCH_BY_DATES = 'zen/syndicatedStoryModal/TOGGLE_RESTRICT_SEARCH_BY_DATES';
const SET_PROPS = 'zen/syndicatedStoryModal/SET_PROPS';
const FETCH_STORIES = 'zen/syndicatedStoryModal/FETCH_STORIES';
const FETCH_STORIES_FAILED = 'zen/syndicatedStoryModal/FETCH_STORIES_FAILED';
const FETCH_STORIES_SUCCEEDED = 'zen/syndicatedStoryModal/FETCH_STORIES_SUCCEEDED';
const FETCH_UNSHOWN_STORIES = 'zen/syndicatedStoryModal/FETCH_UNSHOWN_STORIES';
const FETCH_UNSHOWN_STORIES_SUCCEEDED = 'zen/syndicatedStoryModal/FETCH_UNSHOWN_STORIES_SUCCEEDED';
const SELECTED_STORIES = 'zen/syndicatedStoryModal/SELECTED_STORIES';
const REMOVE_MENTION_FROM_STORE = 'zen/syndicatedStoryModal/REMOVE_MENTION_FROM_STORE';
const REMOVE_MENTIONS = 'zen/syndicatedStoryModal/REMOVE_MENTIONS';
const REMOVE_MENTIONS_FAILED = 'zen/syndicatedStoryModal/REMOVE_MENTIONS_FAILED';
const REMOVE_MENTIONS_SUCCEEDED = 'zen/syndicatedStoryModal/REMOVE_MENTIONS_SUCCEEDED';

const initialState = {
  campaign: {},
  isModalOpen: false,
  isRestrictSearchByDates: true,
  isLoading: false,
  newsroomUrl: '',
  story: {},
  selectedStories: [],
  stories: [],
  unshownStories: [],
  isDeleting : false,
};

/* v8 ignore start */
const _backBoneRefreshSourceList = () => {
  // eslint-disable-next-line no-negated-condition
  return (typeof Vent !== 'undefined') ? Vent.trigger('modified:story_content') : null;
};
/* v8 ignore end */


// Reducer
// eslint-disable-next-line complexity
const reducer = (state = Object.assign({}, initialState), action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case TOGGLE_MODAL:
      return {...state, isModalOpen: !state.isModalOpen};
    case TOGGLE_RESTRICT_SEARCH_BY_DATES:
      return {...state, isRestrictSearchByDates: !state.isRestrictSearchByDates};
    case SET_PROPS:
      return {...initialState, ...payload};
    case FETCH_STORIES:
      return {...state, isLoading: true, stories: []};
    case FETCH_STORIES_FAILED:
      return {...state, isLoading: false};
    case FETCH_STORIES_SUCCEEDED: {
      // TODO: remove this when Pancake stop returning stories with duplicated IDs.
      const stories = uniqBy(payload, 'id');
      return {...state, isLoading: false, stories};
    }
    case FETCH_UNSHOWN_STORIES:
      return {...state, isLoading: true, unshownStories: []};
    case FETCH_UNSHOWN_STORIES_SUCCEEDED: {
      // TODO: remove this when Pancake stop returning stories with duplicated IDs.
      const unshownStories = uniqBy(payload, 'id');
      return {...state, isLoading: false, unshownStories};
    }
    case SELECTED_STORIES: {
      return {
        ...state,
        selectedStories : action.payload
      };
    }
    case REMOVE_MENTION_FROM_STORE: {
      const stories = state.stories.filter((item)=> item.dedup_id !== action.dedupId);
      return {...state, stories};
    }
    case REMOVE_MENTIONS:
      return {...state, isDeleting: true};
    case REMOVE_MENTIONS_FAILED:
      return {...state, isLoading: false, isDeleting : false,};
    case REMOVE_MENTIONS_SUCCEEDED: {
      _backBoneRefreshSourceList();
      const stories = state.stories.filter((item)=> !state.selectedStories.includes(item));
      const isModalOpen = stories.length > 0;
      return {
        ...state,
        stories,
        selectedStories: [],
        isModalOpen,
        isDeleting : false,
      };
    }
    default: return state;
  }
};

// Action Creators
const toggleModalVisibility = () => {
  return { type: TOGGLE_MODAL };
};

const toggleRestrictSearchByDates = () => {
  return { type: TOGGLE_RESTRICT_SEARCH_BY_DATES };
};

const setProps = (payload) => {
  return { type: SET_PROPS, payload };
};

const fetchStories = () => {
  return { type: FETCH_STORIES };
};

const fetchUnshownStories = () => {
  return { type: FETCH_UNSHOWN_STORIES};
};

const fetchStoriesFailed = () => {
  return { type: FETCH_STORIES_FAILED };
};

const fetchStoriesSucceeded = (payload) => {
  return { type: FETCH_STORIES_SUCCEEDED, payload };
};

const fetchUnshownStoriesSucceeded = (payload) => {
  return { type: FETCH_UNSHOWN_STORIES_SUCCEEDED, payload };
};

const selectedStories = (stories) => {
  return { type: SELECTED_STORIES, payload: stories };
};

const removeMentionFromStore = (dedupId) => {
  return { type: REMOVE_MENTION_FROM_STORE, dedupId };
};

const removeMentions = () => {
  return { type: REMOVE_MENTIONS };
};

const removeMentionsFailed = () => {
  return { type: REMOVE_MENTIONS_FAILED };
};

const removeMentionsSucceeded = (payload) => {
  return { type: REMOVE_MENTIONS_SUCCEEDED, payload };
};

export default reducer;
export {
  // Actions
  TOGGLE_MODAL,
  TOGGLE_RESTRICT_SEARCH_BY_DATES,
  SET_PROPS,
  FETCH_STORIES,
  FETCH_STORIES_FAILED,
  FETCH_STORIES_SUCCEEDED,
  FETCH_UNSHOWN_STORIES,
  FETCH_UNSHOWN_STORIES_SUCCEEDED,
  REMOVE_MENTIONS,
  REMOVE_MENTIONS_FAILED,
  REMOVE_MENTIONS_SUCCEEDED,
  REMOVE_MENTION_FROM_STORE,
  SELECTED_STORIES,
  // Action Creators
  toggleModalVisibility,
  toggleRestrictSearchByDates,
  setProps,
  fetchStories,
  fetchStoriesFailed,
  fetchStoriesSucceeded,
  fetchUnshownStories,
  fetchUnshownStoriesSucceeded,
  selectedStories,
  removeMentions,
  removeMentionsFailed,
  removeMentionsSucceeded,
  removeMentionFromStore,
};
